import type {
  BillingPlan,
  BillingSummary,
  BillingUsageRow,
  BillingPlanTier,
} from "@crewledger/shared/schemas";
import { apiFetch } from "@/lib/api";

export async function fetchBillingSummary() {
  return apiFetch<{ data: BillingSummary }>("/api/billing/summary");
}

export async function fetchBillingPlans() {
  return apiFetch<{ data: BillingPlan[] }>("/api/billing/plans");
}

export async function fetchBillingUsage(params?: { page?: number; pageSize?: number }) {
  const search = new URLSearchParams();
  if (params?.page) search.set("page", String(params.page));
  if (params?.pageSize) search.set("pageSize", String(params.pageSize));
  const qs = search.toString();
  return apiFetch<{ data: BillingUsageRow[]; meta: { total?: number } }>(
    `/api/billing/usage${qs ? `?${qs}` : ""}`,
  );
}

export async function updateBillingPlan(planTier: BillingPlanTier) {
  return apiFetch<{ data: BillingSummary["subscription"] }>("/api/billing/subscription", {
    method: "PATCH",
    body: JSON.stringify({ planTier }),
  });
}

export async function createBillingSnapshot(payPeriodId: string) {
  return apiFetch<{ data: BillingUsageRow }>("/api/billing/snapshots", {
    method: "POST",
    body: JSON.stringify({ payPeriodId }),
  });
}
